import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import React, { FC, useState } from "react";
import { useIntl } from "react-intl";
import { GetTranslation } from "../../../../translations/GetTranslation";
import TranslatedMessage from "../../../translations/TranslatedMessage";

type PrivacyPolicyDialogProps = {
  show: boolean;
  handleAccept: () => void;
  handleCancel: () => void;
};

const PrivacyPolicyDialog: FC<PrivacyPolicyDialogProps> = ({ show, handleAccept, handleCancel }) => {
  const [acceptChecked, setAcceptChecked] = useState(false);
  const [highlighCheckbox, setHighlightCheckbox] = useState(false);
  const intl = useIntl();

  const onAcceptClick = () => {
    if (acceptChecked) {
      handleAccept();
    } else {
      setHighlightCheckbox(true);
    }
  };

  const onCancelClick = () => {
    handleCancel();
    setAcceptChecked(false);
    setHighlightCheckbox(false);
  };

  const onCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAcceptChecked(event.target.checked);
    if (event.target.checked) {
      setHighlightCheckbox(false);
    }
  };

  return (
    <Dialog fullWidth={true} maxWidth="md" open={!!show} disableBackdropClick={true}>
      <DialogContent style={{ overflow: "hidden" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              <TranslatedMessage id="startCertification.policyDialog.text1" />(
              <a href="https://www.cicero.ch/" target="_blank" rel="noopener noreferrer">
                www.cicero.ch
              </a>
              ).
            </Typography>
            <Typography style={{ textDecoration: "underline", marginTop: "8px" }}>
              <TranslatedMessage id="startCertification.policyDialog.text2" />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={acceptChecked} onChange={onCheckChange} />}
              label={
                <Typography color={highlighCheckbox ? "error" : "textPrimary"}>
                  <TranslatedMessage id="startCertification.policyDialog.accept" />
                  <a
                    href={GetTranslation(intl, "startCertification.policyDialog.accept.linkUrl")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <TranslatedMessage id="startCertification.policyDialog.accept.link" />
                  </a>
                  .
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick} variant="contained" color="secondary">
          <TranslatedMessage id="common.cancel" />
        </Button>
        <Button onClick={onAcceptClick} variant="contained" color="primary">
          <TranslatedMessage id="common.accept" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyDialog;
